var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 29,
    rx: 29,
    ry: 29,
    transform: "rotate(180 29 29)",
    fill: "#4B4B4B",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9232 29.3985L36.8019 18.4505C36.8647 18.3878 36.9145 18.3133 36.9485 18.2311C36.9825 18.149 37 18.0608 37 17.9719C37 17.8829 36.9825 17.7947 36.9485 17.7126C36.9145 17.6304 36.8647 17.5559 36.8019 17.4932L33.5195 14.19C33.4594 14.1255 33.3867 14.0741 33.3061 14.0389C33.2254 14.0038 33.1385 13.9857 33.0506 13.9857C32.9627 13.9857 32.8757 14.0038 32.7951 14.0389C32.7144 14.0741 32.6418 14.1255 32.5817 14.19L17.8446 29.0209C17.7805 29.0815 17.7295 29.1546 17.6946 29.2357C17.6596 29.3169 17.6417 29.4044 17.6417 29.4928C17.6417 29.5813 17.6596 29.6688 17.6946 29.7499C17.7295 29.8311 17.7805 29.9042 17.8446 29.9647L32.5817 44.7957C32.6418 44.8602 32.7145 44.9116 32.7951 44.9467C32.8757 44.9819 32.9628 45 33.0506 45C33.1385 45 33.2254 44.9819 33.3061 44.9467C33.3867 44.9116 33.4594 44.8602 33.5195 44.7957L36.8019 41.4924C36.8647 41.4298 36.9145 41.3552 36.9485 41.2731C36.9825 41.1909 37 41.1028 37 41.0138C37 40.9248 36.9825 40.8367 36.9485 40.7545C36.9145 40.6724 36.8647 40.5978 36.8019 40.5352L28.174 31.8658",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/icon_left_arrow.6ee864168a43e0a405264aa7275416b6.svg";
export { ForwardRef as ReactComponent };